import * as types from './types'
import { loadTablePaginationSize } from './utils'

const initial = {
  configuredTable: {},
  unsetConfiguredTable: {},
  viewTable: false,
  tableData: {},
  notification: {},
  timers: {},
  offerPrice: {},
  status: {
    negotiation: {
      launchType: ['NORMAL', 'QUOTATION', 'AUCTION', 'RANK_TABLE'],
      orderBy: null,
    },
    in_progress: {
      searchStatus: [
        'WAIT_BIND_DRIVER',
        'WAIT_ACCEPT_DRIVER',
        'BIND_DRIVER',
        'IN_COLLECT',
        'IN_TRANSIT',
        'IN_DELIVERY',
      ],
      orderBy: null,
    },
    delivered: {
      searchStatus: ['WAIT_APPROVE_RECEIPT', 'REFUSED_RECEIPT', 'APPROVED_RECEIPT'],
      orderBy: null,
    },
  },
  type: 'negotiation',
}
const loadTable = (state = initial, { type, payload }) => {
  switch (type) {
    case types.SET_LOAD_TYPE:
      return {
        ...state,
        type: payload.type,
      }
    case types.TABLE_NOTIFICATION:
      return {
        ...state,
        notification: {
          feedbackTitle: payload.title,
          feedbackDescription: payload.description,
        },
      }
    case types.FETCH_CONFIGURED_TABLE:
      return {
        ...state,
        configuredTable: payload,
      }
    case types.SET_VIEW_TABLE:
      return {
        ...state,
        viewTable: payload.checked,
      }
    case types.FIRST_FETCH_CONFIGURED_TABLE:
      return {
        ...state,
        configuredTable: {
          negotiation: payload.config.NEGOTIATION,
          in_progress: payload.config.IN_PROGRESS,
          delivered: payload.config.DELIVERED,
        },
      }
    case types.FIRST_FETCH_UNSET_CONFIGURED_TABLE:
      return {
        ...state,
        unsetConfiguredTable: {
          negotiation: payload.config.NEGOTIATION,
          in_progress: payload.config.IN_PROGRESS,
          delivered: payload.config.DELIVERED,
        },
      }

    case types.FETCH_DATA_FROM_TABLE:
      return {
        ...state,
        tableData: {
          negotiation: {
            page: 1,
            data: payload.negotiation,
            hasMore: payload.negotiation.rows.length >= loadTablePaginationSize,
          },
          in_progress: {
            page: 1,
            data: payload.in_progress,
            hasMore: payload.in_progress.rows.length >= loadTablePaginationSize,
          },
          delivered: {
            page: 1,
            data: payload.delivered,
            hasMore: payload.delivered.rows.length >= loadTablePaginationSize,
          },
        },
      }
    case types.FETCH_DATA_BY_STATUS:
      return {
        ...state,
        tableData: {
          ...state.tableData,
          [payload.status]: {
            page: payload.page,
            data:
              payload.page === 1
                ? payload.data
                : {
                    ...state.tableData[payload.status].data,
                    rows: [...state.tableData[payload.status].data.rows, ...payload.data.rows],
                  },
            hasMore: payload.data.rows.length >= loadTablePaginationSize,
          },
        },
      }
    case types.CLEAR_TABLE_DATA:
      return {
        ...state,
        tableData: {},
      }
    case types.CLEAR_STATUS:
      return {
        ...state,
        status: { ...initial.status },
      }
    case types.FETCH_DATA_TABLE_WITH_PARAMS:
      return {
        ...state,
        tableData: {
          ...state.tableData,
          [payload.status]: {
            data: payload[payload.status],
            hasMore: payload[payload.status].rows.length >= loadTablePaginationSize,
            page: payload.page,
          },
        },
      }

    case types.FETCH_MORE_DATA_ON_TABLE:
      return {
        ...state,
        tableData: {
          ...state.tableData,
          [payload.status]: {
            data: {
              ...state.tableData[payload.status].data,
              rows: [...state.tableData[payload.status].data.rows, ...payload.data.rows],
            },
            hasMore: payload.data.rows.length >= loadTablePaginationSize,
            page: payload.page,
          },
        },
      }
    case types.HANDLE_FAST_FILTER:
      return {
        ...state,
        status: {
          ...state.status,
          [payload.type]: {
            ...state.status[payload.type],
            [payload.field]: payload.filter,
            orderBy: payload.orderBy,
          },
        },
      }
    case types.CHANGE_FAST_FILTER:
      return {
        ...state,
        tableData: {
          ...state.tableData,
          [payload.status]: {
            data: {
              ...state.tableData[payload.status].data,
              rows: payload.data.rows,
              amounts: payload.data.amounts,
            },
            hasMore: payload.data.rows.length >= loadTablePaginationSize,
            page: 1,
          },
        },
      }
    case types.SET_TIMER:
      return {
        ...state,
        timers: {
          ...state.timers,
          [payload.id]: {
            timer: payload.timer,
          },
        },
      }
    case types.SET_OFFER_PRICE:
      return {
        ...state,
        offerPrice: {
          ...state.offerPrice,
          [payload.id]: {
            price: payload.offer,
          },
        },
      }
    case types.CLEAN_TABLE_STATE:
      return initial
    default:
      return state
  }
}
export default loadTable
